import React from "react";
import UserFace from "../../../assets/img/avatar-face.jpg";
import constants from "../../../utilities/constants.json";
import { Link } from "react-router-dom";
import Moment from "moment";

import "./previousDayWinners.css";

const imageUrl = constants.profile_image;

const PreviousDayWinners = (prop) => {

  return (
    <div className="previousDayWinners">
      <div className="previousDayWinners-wrapper">
        <div className="previousDayWinners-topSection">
          <div className="previousDayWinners-title-wrapper">
            <h5>{prop.day} Winner</h5>
            {/* <span className="previousDayWinners-date">{dateDisplay}</span> */}
          </div>
          {/*<div className="previousDayWinnres-sponsor-img">*/}
          {/*  <img src={Logo} alt="" />*/}
          {/*</div>*/}
        </div>
        <div className="previousDayWinners-middleSection">
          <div className="previousDayWinners-middle-wrapper">

            {prop.leaderboard ? (
              prop.leaderboard.map((winners) => (
                <div className="previousDayWinners-playerOne">
                  <div className="playerImg">
                    <img
                      src={winners.image ? imageUrl + winners.image : UserFace}
                      alt=""
                      onError={(e) =>
                          (e.target.onerror = null)(
                              (e.target.src =UserFace)
                          )}
                    />
                  </div>
                  <p className="playerName">{winners.name}</p>
                  <p className="playerPoints">{winners.score} Pts</p>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="previousDayWinners-bottomSection">
          <div className="previousDayWinners-bottom-wrapper">
            <div className="previousDayWinners-divider"></div>
            <Link to='/mobile-leaderboard'>
              <p className="previousDayWinners-leaderboard">View Leaderboard</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviousDayWinners;
